import { useState, useEffect } from 'react';
import { IDeaRegistration, teamEnableRoles, useDeaRegistrations } from '..';
import {
  compose as lcompose,
  filter as lfilter,
  map as lmap,
  orderBy as lorderBy,
  anyPass,
  eq as leq,
} from 'lodash/fp';
import { path } from 'rambda';

export const useDeaRegistrationSearch = () => {
  const { deaRegistrations } = useDeaRegistrations();

  const [input, setInput] = useState('');
  const [options, setOptions] = useState<IDeaRegistration[]>([]);

  useEffect(() => {
    lcompose(
      setOptions,

      lorderBy(['deaNum'], ['asc']),

      lfilter(
        anyPass(
          lmap<string, (b: IDeaRegistration) => boolean>(role =>
            lcompose(leq(role), path('role'))
          )(teamEnableRoles)
        )
      ),

      lfilter<IDeaRegistration>({
        regStatus: 'ACTIVE',
      })
    )(deaRegistrations);
  }, [deaRegistrations]);

  return {
    deaRegistrations: options,
    deaRegistrationSearchInput: input,
    setDeaRegistrationSearchInput: setInput,
  };
};
